import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import Link from 'next/link';
import { useTranslation } from '@/src/i18n';
import Dialog from '@/components/molecules/Dialog/Dialog';
import { APP_ROUTES } from '@/src/constants';

export type RejectionDialogStatus =
  | 'notProtectedPatient'
  | 'linkExpired'
  | 'zeroQuota'
  | 'invalidTime'
  | 'linkMutualExpired'
  | 'tooYoung'
  | null;

const RejectionData = [
  {
    id: 'notProtectedPatient',
    title: 'no_access',
    subtitle: 'patient_without_rights_subtitle',
    body: 'patient_without_rights_body',
  },
  {
    id: 'zeroQuota',
    title: 'no_access',
    subtitle: 'no_quota_left_subtitle',
    body: 'no_quota_left_body',
  },
  {
    id: 'invalidTime',
    title: 'no_access',
    subtitle: 'outside_time_range_subtitle',
    body: 'outside_time_range_body',
  },
  {
    id: 'linkExpired',
    title: 'expired_rights',
    subtitle: 'expired_rights_subtitle',
    body: 'expired_rights_body',
  },
  {
    id: 'linkMutualExpired',
    title: 'expired_rights',
    subtitle: 'expired_mutual_rights_subtitle',
    body: 'expired_mutual_rights_body',
  },
  {
    id: 'tooYoung',
    title: 'tlc_amc_too_young_title',
    subtitle: 'tlc_amc_too_young_subtitle',
    body: 'tlc_amc_too_young_body',
  },
];

type Props = {
  rejectionReason: RejectionDialogStatus;
  isOpen: boolean;
  clearRejection: () => void;
};

const RejectionDialog = ({
  rejectionReason,
  isOpen,
  clearRejection,
}: Props) => {
  const { t } = useTranslation();
  const rejectObj = RejectionData.find(reject => reject.id === rejectionReason);

  return (
    <Dialog
      title={t(`${rejectObj?.title ?? ''}`)}
      open={isOpen}
      onClose={clearRejection}
    >
      <DialogContent>
        <Box py={2.5} textAlign="center">
          <CancelIcon sx={{ fontSize: '100px' }} color="secondary" />
        </Box>
        <Typography variant="h3" color="secondary" textAlign="center">
          {t(`${rejectObj?.subtitle}`)}
        </Typography>
        <Typography>{t(`${rejectObj?.body}`)}</Typography>
        <Typography color="primary" mt={1.5}>
          <Link href={APP_ROUTES.TLC.NO_RDV_SEARCH} passHref legacyBehavior>
            {t('expired_rights_link')}
          </Link>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={4}>
          <Button variant="contained" color="primary" onClick={clearRejection}>
            {t('understand_btn')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default RejectionDialog;
